import { holidayServiceApi } from "../../app/holidayServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  DeleteHolidayType,
  GetHolidayByDateParams,
  GetHolidayDetailsResponseType,
  GetHolidayParams,
  GetHolidayResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const holidayManagementApi = holidayServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getHolidays: builder.query<
      GetHolidayResponseType,
      GetQueryArgsType<GetHolidayParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getHolidays,
        ...queryArgs,
      }),
      providesTags: ["GetHolidays"],
    }),
    getHolidaysByDate: builder.query<
      GetHolidayResponseType,
      GetQueryArgsType<GetHolidayByDateParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getHolidaysByDate,
        ...queryArgs,
      }),
      providesTags: ["GetHolidaysByDate"],
    }),
    getHolidayDetails: builder.query<GetHolidayDetailsResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getHolidayDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetHolidayDetails", id }],
    }),
    addHoliday: builder.mutation({
      query: (data) => ({
        url: API_URL.addHoliday,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetHolidays", "GetHolidaysByDate"];
        return [];
      },
    }),
    updateHoliday: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateHoliday}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetHolidays",
            "GetHolidaysByDate",
            {
              type: "GetHolidayDetails",
              id,
            },
          ];

        return [];
      },
    }),
    // Delete
    deleteHoliday: builder.mutation<void, DeleteHolidayType>({
      // query: ({ body, id }) => ({
      query: ({ id }) => ({
        url: `${API_URL.deleteHoliday}/${id}`,
        method: "DELETE",
        // body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetHolidays",
            "GetHolidaysByDate",
            {
              type: "GetHolidayDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetHolidaysQuery,
  useGetHolidaysByDateQuery,
  useGetHolidayDetailsQuery,
  useAddHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
} = holidayManagementApi;
